import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import './Header.css';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { lang, toggleLang, t } = useLanguage();

  const navLinks = [
    { label: 'Accueil', to: '/' },
    { label: 'Nos Réalisations', to: '/realisations' },
    { label: 'Catalogue', to: '/catalogue' },
    { label: 'Savoir-Faire', to: '/#services' },
    { label: 'Architectes & Pro', to: '/partenaires' },
    { label: 'Contact', to: '/contact' },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <>
      <header className={`header${scrolled ? ' header--scrolled' : ''}`}>
        <div className="header__inner container">
          {/* Logo */}
          <Link to="/" className="header__logo" aria-label="Luxury Wood Concept">
            <img 
              src="/logo-luxury-wood-concept-header-500px.png" 
              alt="Luxury Wood Concept" 
              className="header__logo-img"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="header__nav">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`header__nav-link${location.pathname === link.to ? ' active' : ''}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Right Actions */}
          <div className="header__right">
            {/* Language toggle hidden for now as per user request */}
            {/* <button 
              className="header__lang-toggle" 
              onClick={toggleLang}
              aria-label="Toggle language"
            >
              {lang === 'fr' ? 'AR' : 'FR'}
            </button> */}
            <a
              href="https://wa.me/212661338406?text=Bonjour%20Luxury%20Wood%20Concept%2C%20je%20voudrais%20demander%20un%20devis."
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary header__cta"
            >
              {t('nav.quote')}
            </a>
            <button
              className={`header__burger${menuOpen ? ' open' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Menu"
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Overlay (dark backdrop) */}
      <div 
        className={`mobile-overlay${menuOpen ? ' mobile-overlay--visible' : ''}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* Mobile Side Panel */}
      <div className={`mobile-menu${menuOpen ? ' mobile-menu--open' : ''}`}>
        <div className="mobile-menu__header">
          <div className="mobile-menu__brand">
            <img 
              src="/logo-luxury-wood-concept-header-500px.png" 
              alt="Luxury Wood Concept" 
              className="mobile-menu__logo-img" 
            />
          </div>
          <button
            className="mobile-menu__close-btn"
            onClick={() => setMenuOpen(false)}
            aria-label="Fermer le menu"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <nav className="mobile-menu__nav">
          {navLinks.map((link, i) => (
            <Link
              key={link.to}
              to={link.to}
              className="mobile-menu__link"
              onClick={() => setMenuOpen(false)}
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <span className="mobile-menu__chevron">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
              </span>
              {link.label}
            </Link>
          ))}
          <Link
            to="/login"
            className="mobile-menu__link"
            onClick={() => setMenuOpen(false)}
            style={{ transitionDelay: `${navLinks.length * 60}ms` }}
          >
            <span className="mobile-menu__chevron">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
            Connexion
          </Link>
        </nav>

        <div className="mobile-menu__footer">
          <a
            href="https://wa.me/212661338406?text=Bonjour%20Luxury%20Wood%20Concept%2C%20je%20voudrais%20demander%20un%20devis."
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary mobile-menu__cta"
          >
            Devis Rapide sur WhatsApp
          </a>
          <a
            href="tel:+212661338406"
            className="btn btn-ghost mobile-menu__phone-btn"
            style={{ marginTop: '10px', width: '100%', justifyContent: 'center', borderColor: 'rgba(201, 169, 110, 0.4)' }}
          >
            Appeler l'Atelier
          </a>
        </div>
      </div>
    </>
  );
}
